import React from 'react';
import PropTypes from 'prop-types';

import MartyLink from 'components/common/MartyLink';
import marketplace from 'cfg/marketplace.json';
import css from 'styles/components/account/accountNavList.scss';

const { account: { manageAccountUrl, emailSubscriptionUrl } } = marketplace;

const handleTouchStart = ({ target }) => {
  target.classList.add(css.active);
};

const handleTouchEnd = ({ target }) => {
  target.classList.remove(css.active);
};

const makeNavLink = (url, name, testId) => (
  <li role="menuitem">
    <MartyLink
      to={url}
      className={css.navLinkArrow}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      data-test-id={testId}>
      <span>{name}</span>
    </MartyLink>
  </li>
);

const makeAccountInfoLink = testId => (
  <li role="menuitem">
    <a
      className={css.navLinkArrow}
      href={manageAccountUrl}
      data-test-id={testId}>
      Account Information
    </a>
  </li>
);

const AccountNavList = ({ showAccountRewards, hideEmailSubscriptionLink, hideFavoritesLink }, { testId }) => (
  <ul className={css.accountNavList} role="group">
    {makeNavLink('/orders', 'View Order History', testId('orderHistory'))}
    {!hideFavoritesLink && makeNavLink('/account/favorites', 'Favorites', testId('favorites'))}
    {showAccountRewards && makeNavLink('/rewards/dashboard', 'Rewards', testId('rewards'))}
    {makeNavLink('/payments', 'Payment Information', testId('managePayments'))}
    {makeNavLink('/addresses', 'Shipping Information', testId('manageAddresses'))}
    {makeAccountInfoLink(testId('manageAccountInfo'))}
    {!hideEmailSubscriptionLink && makeNavLink(emailSubscriptionUrl, 'Subscriptions', testId('manageEmails'))}
  </ul>
);

AccountNavList.propTypes = {
  showAccountRewards: PropTypes.bool
};

AccountNavList.contextTypes = {
  testId: PropTypes.func
};

export default AccountNavList;
